import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import http from 'axios'

import { Accordion, AccordionDetails, AccordionSummary, Icon, Typography } from '@mui/material'
import { withStyles } from '@mui/styles'
import { style } from 'styles'
import Products from './components/Products'
import { saveAccess } from 'core/lib'

function ProductsListGroupped({ classes }) {
	const dispatch = useDispatch()
	const { products } = useSelector(state => state.products)

	useEffect(() => {
		const loadProducts = async() => {
			const products = await http.get(`${window.__endpoint}/api/products`)
			dispatch({ type: 'loadProducts@products', products: products })

			// Salvo l'accesso
			saveAccess('products-list')
		}

		dispatch({ type: 'loadProducts@products', products: null })
		loadProducts()
	}, [])

	return (<div className={classes.page} style={{ width: '91vw' }}>
		{products && products.map((category, c) => (<Accordion key={c}>
			<AccordionSummary
				expandIcon={<Icon>expand_more</Icon>}
			>
				<Typography className={classes.pageTitle}>{category.name}</Typography>
			</AccordionSummary>
			<AccordionDetails style={{ padding: '0 5px' }}>
				<Products
					products={category.products}
				/>
			</AccordionDetails>
		</Accordion>))}
	</div>)
}

export default withStyles(style)(ProductsListGroupped)
